<template>
  <!-- 藏品列表 -->
  <div class="page-collect">
    <div class="g-banner white">
      <cmpBanner bannerType="3"></cmpBanner>

      <div class="g-tab-box">
        <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
      </div>
    </div>

    <div class="g-content-wrap g-pad-top">
      <div class="wrap g-pad-bottom-2">
        <!-- 左侧分类 -->
        <div class="overlay" v-show="showMenu" @click="closeMenu">
          <div class="menu-cont">
            <a class="icon-close" @click="closeMenu">
              <img src="~@images/icon-close.png" alt="">
            </a>
            <div class="menu-left" @click.stop="aa">
              <div class="menu-item">
                <p class="title">分类</p>
                <cmpCheckAll ref="cmpCheckAll" @eventChecked="eventChecked" :checkData="checkData"></cmpCheckAll>
              </div>

              <div class="menu-item">
                <p class="title">年代</p>
                <cmpCheckAll ref="cmpCheckAll" @eventChecked="eventChecked2" :checkData="checkData2"></cmpCheckAll>
              </div>
            </div>
          </div>
        </div>

        <div class="right">
          <!-- 搜索条件 -->
          
          <div class="header mb-40">
            <el-form class="com-search-box" ref="form" :model="form" label-width="0">
              <el-row :gutter="0">
                <el-form-item label="" prop="name">
                  <el-input class="myinput" v-model="form.name" clearable placeholder="文物名称：" @keyup.enter.native="handleSearch"></el-input>
                  <!-- 勿删 解决刷新 -->
                  <input type="text" style="display:none" />
                </el-form-item>
              </el-row>
            </el-form>
            <el-button class="btn-search" type="primary" @click="handleSearch">搜索</el-button>
            <!-- <div class="com-head-search-btns">
              <el-button type="primary" @click="handleSearch">搜索</el-button>
            </div> -->
          </div>

          <div class="top-box">
            <div class="menu-box">
              <span class="icon" @click="showMenu=true"><i></i></span>
              <p class="total m-font-5"><span class="count">{{total | thousandsFormat}}</span> 件/套</p>
            </div>
            <!-- 切换视图 -->
            <div class="right-btns" style="display:none;">
              <a class="btn-view" :class="{'active': showType==='1'}" @click="toggleView('1')"><i></i></a>
              <a class="btn-view" :class="{'active': showType==='2'}" @click="toggleView('2')"><i></i></a>
            </div>
          </div>

          <!-- <div class="title-box">
            <img class="title-pic" src="@images/collect-list.jpg" alt="">
            <div class="title-desc">
              <div>
                <p class="mb-10">共公开</p>
                <p><span class="count">{{total | thousandsFormat}}</span> 件藏品</p>
              </div>
            </div>
          </div> -->

          <div class="list-box" v-show="showType==='1'">
            <div class="list masonry-container" v-masonry transition-duration="0" item-selector=".item" :gutter="gutter">
              <div v-masonry-tile class="item" :class="{'min': gutter<25}" v-for="(item, index) in dataList" :key="index" @click="goDetailCollect(item)">
                <div class="pic-box">
                  <img :src="item.mainCollectImages" alt="">
                  <!-- <div class="tag-box">
                    <span class="tag">{{item.categoryName}}</span>
                    <span class="tag">{{item.yearName}}</span>
                  </div> -->
                </div>
                <div class="info">
                  <h2 class="ell m-font-3">{{item.collectName}}</h2>
                  <p class="m-font-4">{{item.collectYear}}</p>

                  <!-- <myCmpLike class="like-box" :isLike="item.iscollection?true:false" :likeId="item.id" :type="`1`" style="top:20px;"></myCmpLike> -->
                </div>
              </div>

              <!-- 无数据 -->
              <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
                <div class="no-data-bg"></div>
                <p class="txt text-center">暂无数据</p>
              </div>
            </div>
          </div>

          <!-- 列表视图 -->
          <div class="list-items" style="display: none;">
            <div class="it" v-for="(item, i) in dataList" :key="i">
              <!-- <div class="pic-box">
                <img src="" alt="">
              </div> -->
              <p class="name m-font-2">{{item.collectName}}</p>
              <span class="tag m-font-4" v-if="!item.collectYear">{{item.collectType}}</span>
              <span class="tag m-font-4" v-else>{{item.collectType}} / {{item.collectYear}}</span>
            </div>
          </div>

          <!-- 列表视图 -->
          <div class="table mt-20" v-show="showType==='2'">
            <el-table
              ref="multipleTable"
              v-loading="listLoading"
              :header-cell-style="{
                background: '#F6F6F6',
                fontWeight: 'normal',
                color: '#000',
              }"
              :data="dataList"
              @row-click="handleRowClick"
              v-horizontal-scroll="'always'"
            >
              <!-- <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column> -->
              <el-table-column prop="imgUrl" label="藏品图片" width="220">
                <template slot-scope="scope">
                  <!-- <viewer :options="{ url: 'data-maxUrl' }">
                    <img
                      class="g-table-pic g-pointer"
                      :src="scope.row.imgUrl || ''"
                      :data-maxUrl="scope.row.imgUrl"
                      alt
                      :onerror="$store.state.app.defaultImg"
                    >
                  </viewer> -->
                  <div @click.stop="stopFun">
                    <img
                      class="g-table-pic g-pointer"
                      :src="scope.row.imgUrl || ''"
                      alt
                      :onerror="$store.state.app.defaultImg"
                      :preview="scope.row.collectId" preview-text=""
                    >
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column prop="collectName" label="藏品名称" min-width="300px" show-overflow-tooltip></el-table-column>
              <!-- <el-table-column label="计划名称" min-width="14%" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a
                    class="m-btn"
                    @click="showCreatePlan('detail', scope.row.schemeId)"
                  >{{ scope.row.schemeName }}</a>
                </template>
              </el-table-column> -->
              <el-table-column prop="collectYear" label="年代" min-width="200px" show-overflow-tooltip></el-table-column>
              <el-table-column prop="collectType" label="类别" min-width="200px"></el-table-column>
              <el-table-column prop="collectLevel" label="级别" min-width="200px"></el-table-column>
              <el-table-column prop="collectTexture" label="质地" min-width="200px"></el-table-column>
              <el-table-column prop="detailSize" label="尺寸" min-width="200px" show-overflow-tooltip></el-table-column>
            </el-table>
          

            <cmpMyPagination style="margin-top:100px;" :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total" @eventPage="eventPage" v-if="showType==='2'"></cmpMyPagination>
          </div>
        </div>
      </div>

      <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total" @eventPage="eventPage" v-if="showType==='1'"></cmpMyPagination>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {VueMasonryPlugin} from 'vue-masonry'
Vue.use(VueMasonryPlugin)
import horizontalScroll from 'el-table-horizontal-scroll'
Vue.use(horizontalScroll)

import cmpTab from '@cmp/tab'
import myCmpLike from '@cmp/my-like'

import cmpCheckAll from './check-all'
export default {
  components: { cmpTab, myCmpLike, cmpCheckAll },
  watch: {
    showMenu(newVal) {
      console.log(newVal)
      if(newVal) {
        document.getElementById('app').style.overflow = 'hidden'
      } else {
        document.getElementById('app').style.overflow = 'initial'
      }
    }
  },
  data() {
    return {
      showMenu: false,
      showType: '2',  // 1卡片视图 2列表
      activeVal: '3',
      tabList: [
        {
          name: '馆藏精品',
          val: '1'
        },
        {
          name: '3D 藏品',
          val: '2'
        },
        {
          name: '数字文物库',
          val: '3'
        },
        // {
        //   name: '文物素材库',
        //   val: '4'
        // }
      ],
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 20,
      },
      total: 0,
      listLoading: true,
      form: {
        year: '',
        category: '',
        // orgId: '',
        name: '',
      },
      totalCol: 0,
      yearList: [],
      typeList: [],
      orgList: [],

      checkData: [],
      checkData2: [],
      gutter: 25
    }
  },
  methods: {
    getDataList() {
      if(this.showType === '2') {
        this.getDataList2()
        return
      }

      this.listLoading = true
      this.$http
        // .get('/collection/getCollectionList.do', {
        .get('../singleMuseum/bs/bsDigitalRelics/list', {
          ...this.form,
          ...this.listQuery,
          // isHighQuality: '' // 1 普通 2 精品
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            // this.dataList = res.data
            // this.total = res.page.allRow
            let data = res.result || {}
            this.dataList = data.records
            data.records.map(item => {
							if (item.collectImages) {
								item.mainCollectImages = item.collectImages[0] && item.collectImages[0].attPath
							} else {
								item.mainCollectImages = ''
							}
              console.log(item)
						})

            this.total = data.total

            this.reDraw()

            this.$previewRefresh()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 列表视图
    getDataList2() {
      this.listLoading = true
      this.$http
        .get('../singleMuseum/szwwkt/list', {
          ...this.form,
          ...this.listQuery,
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.dataList = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },
    stopFun() {},
    handleRowClick(item) {
      this.$router.push({
        path: '/collect/detail',
        query: {id: item.collectId, pageType: '3'}
      })
    },
    reDraw() {
      this.$nextTick(() => {
        if(document.body.clientWidth < 1440) {
          this.gutter = 20
        } else {
          this.gutter = 25
        }
        setTimeout(() => {
          this.$redrawVueMasonry()
        }, 500)
      })
    },
    getDictData() {
      this.$http
        .post('../singleMuseum/collectDict/getSelectDataByArr', {
          arr: ['collection_type', 'collection_year']
        }).then(res => {
          if (res.success) {
            this.checkData = res.result.collection_type
            this.checkData2 = res.result.collection_year

            this.getDataList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getDictData2() {
      this.$http
        .get('../singleMuseum/szwwkt/dict', {}).then(res => {
          if (res.success) {
            let data = res.result
            data.category.map(item => {
              item.dictName = item.name
              item.dictCode = item.id
            })
            data.yearType.map(item => {
              item.dictName = item.name
              item.dictCode = item.id
            })
            this.checkData = data.category
            this.checkData2 = data.yearType

            this.getDataList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    toggleView(type) {
      if(this.showType === type) return
      this.showType = type
      if(this.showType === '1') {
        this.listQuery.size = 20
        // this.reDraw()
      } else {
        this.listQuery.size = 15
      }
      this.dataList = []
      this.handleSearch()
    },
    handleSearch() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    goDetailCollect(item) {
      this.$router.push({
        path: '/collect/detail',
        query: {id: item.collectId, pageType: '3'}
      })
    },
    goDetailTopic(item) {
      this.$router.push({
        path: '/collect/topic/detail',
        query: {id: '1'}
      })
    },
    closeMenu() {
      this.showMenu = false
      this.handleSearch()
    },
    // 获取选择的分类
    eventChecked(fileArr) {
      console.log(fileArr)
      this.form.category = fileArr.join(',')
      // this.handleSearch()
    },
    eventChecked2(fileArr) {
      console.log(fileArr)
      this.form.year = fileArr.join(',')
      // this.handleSearch()
    },
    eventTabClick(val) {
      if(val === this.activeVal) return
      this.activeVal = val
      if(val === '1') {
        this.$router.push('/collect')
      } else if(val === '2') {
        this.$router.push('/collect/list')
      } else if(val === '3') {
        this.$router.push('/collect/digital-culture')
      } else if(val === '4') {
        this.$router.push('/collect/material')
      }
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getDataList()

      window.scrollTo({
        top: 0
      })
    },
    aa() {}
  },
  created() {
    if(this.showType === '2') {
      this.listQuery.size = 15
      this.getDictData2()
    } else {
      this.getDictData()
    }
  },
  mounted() {
    window.addEventListener('resize', this.reDraw)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reDraw)
  }
}
</script>

<style lang="scss" scoped>
.page-collect {
  // background: #D4BE95;
  // color: #fff;
  .wrap {
    display: flex;
    justify-content: space-between;
  }
  .overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(75,67,59,.7);
    z-index: 8;
    overflow: hidden;
    .menu-cont {
      padding-left: 36px;
      padding-top: 100px;
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      top: 30vh;
      left: 0;
      background: #F6F6F6;
    }
    .icon-close {
      position: absolute;
      left: 36px;
      top: 36px;
      z-index: 2;
      img {
        width: 40px;
      }
    }
  }
  .menu-left {
    padding-right: 36px;
    padding-bottom: 250px;
    box-sizing: border-box;
    width: 100%;
    // height: 100%;
    height: 70vh;
    overflow-y: auto;
    margin-right: 40px;
    .menu-item {
      margin-bottom: 60px;
      // padding-bottom: 50px;
      // width: 272px;
      width: 100%;
      background: rgba($color: #F6F6F6, $alpha: 0.7);
      box-sizing: border-box;
      .title {
        padding-left: 40px;
        font-size: 32px;
        line-height: 70px;
        color: #fff;
        background: #AE8148;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
      }
    }
  }


  .title-box {
    margin-top: 40px;
    position: relative;
    .title-pic {
      width: 100%;
      height: 136px;
    }
    .title-desc {
      position: absolute;
      left: 50px;
      top: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 136px;
      font-size: 18px;
      color: #fff;
      h1 {
        font-size: 36px;
      }
      .count {
        font-size: 38px;
        font-weight: bold;
      }
    }
  }

  .right {
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    .top-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      line-height: 60px;
      .menu-box {
        display: flex;
        align-items: center;
        .icon {
          display: flex;
          padding: 10px;
          i {
            width: 49px;
            height: 50px;
            background: url(~@images/icon_filter@2x.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }
        .total {
          margin-left: 40px;
        }
      }
    }

    .right-btns {
      margin-left: 60px;
      width: 160px;
      height: 64px;
      border: 1px solid #F6F6F6;
      display: flex;
      .btn-view {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        &:first-child {
          i {
            width: 38px;
            height: 38px;
            background: url(~@images/btn-view-1.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }
        &:last-child {
          i {
            width: 38px;
            height: 38px;
            background: url(~@images/btn-view-2.png) no-repeat center center;
            background-size: 100% 100%;
          }
        }
        &.active {
          background: $primary;
          &:first-child {
            i {
              background: url(~@images/btn-view-1-active.png) no-repeat center center;
              background-size: 100% 100%;
            }
          }
          &:last-child {
            i {
              background: url(~@images/btn-view-2-active.png) no-repeat center center;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
  }
  .header {
    display: flex;
    font-size: 24px;
    color: rgba($color: #000000, $alpha: 0.7);
    align-items: center;

    .com-search-box {
      flex: 1;
    }
    .myinput {
      // width: 580px;
    }
    .btn-search {
      width: 136px;
    }
    .el-form-item {
      margin-bottom: 0;
    }
    
  }
  .masonry-container {
    .g-card-list {
      display: initial;
    }
    .item {
      margin-bottom: 35px;
      width: 375px;
      cursor: pointer;
      &.min {
        width: 360px;
      }
      img {
        width: 100%;
      }
      .info {
        padding: 28px 40px;
        background: rgba($color: #E1D9C8, $alpha: 0.4);
        // color: #fff;
        h2 {
          // font-size: 24px;
          margin-bottom: 15px;
        }
      }
    }
  }

  .list-items {
    .it {
      display: flex;
      align-items: center;
      // height: 96px;
      height: 70px;
      .pic-box {
        position: relative;
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #F9F9F9;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .name {
        margin-left: 30px;
        color: #000000;
      }
      .tag {
        color: $primary;
        margin-left: 30px;
      }
      // &:hover {
      //   padding-left: 40px;
      //   background: #F9F9F9;
      //   .pic-box {
      //     background: #D8D7D7;
      //   }
      // }
    }
  }

  /deep/ .el-table {
    th {
      .cell {
        font-size: 24px;
      }
    }
    .cell {
      font-size: 24px;
      line-height: 36px;
    }

    .el-table__body {
      // width: 2000px !important;
    }

    .el-table__body-wrapper {
      width: 100%;
      // z-index: 2;
      overflow-y: hidden;
      overflow-x: auto;
      // -webkit-overflow-scrolling: touch;
      -webkit-overflow-scrolling: auto;
    }

    // .el-table__body-wrapper::-webkit-scrollbar {
    //   width: 8px; // 横向滚动条
    //   height: 8px; // 纵向滚动条 必写
    // }
    // .el-table__body-wrapper::-webkit-scrollbar-thumb {
    //   background-color: #dde;
    //   border-radius: 3px;
    // }
  }
  // /deep/ .el-tooltip__popper .popper__arrow {
  //   top: 20px;
  // }

  /deep/ .el-input {
    .el-input__inner {
      // color: rgba($color: #000000, $alpha: 0.7);
      &::placeholder { 
        color: rgba($color: #000000, $alpha: 0.5);
      }
    }
  }
  /deep/ .el-select:hover .el-input__inner {
    border-color: #fff;
  }
  /deep/ .el-select .el-input .el-select__caret {
    color: $primary;
  }
}
</style>